export enum BrandclubEventType {
    PageView = 'PageView',
    NavigateToRetailer = 'NavigateToRetailer',
    AddToCart = 'AddToCart',
    OrderSubmitted = 'OrderSubmitted',
    PurchaseConfirmed = 'PurchaseConfirmed',
    ViewCart = 'ViewCart',
    InitiateCheckout = 'InitiateCheckout',
    OrderConfirmation = 'OrderConfirmation',
}
// Add an interface for the tracking pixel structure
export interface TrackingPixel {
    pixelProvider: string;
    eventFilter?: string;
    eventMapping?: {
        pageView?: {
            enabled: boolean;
            mappedEventName: string;
        };
        addToCart?: {
            enabled: boolean;
            mappedEventName: string;
        };
        orderSubmitted?: {
            enabled: boolean;
            mappedEventName: string;
        };
        purchaseConfirmed?: {
            enabled: boolean;
            mappedEventName: string;
        };
        navigateToRetailer?: {
            enabled: boolean;
            mappedEventName: string;
        };
        viewCart?: {
            enabled: boolean;
            mappedEventName: string;
        };
        initiateCheckout?: {
            enabled: boolean;
            mappedEventName: string;
        };
        orderConfirmation?: {
            enabled: boolean;
            mappedEventName: string;
        };
    };
    [key: string]: any;
}

// Import LDUOptions type for TrackingOptions
// Actual implementation lives in limitedDataUse.ts
import type { LDUOptions } from './limitedDataUse';

/**
 * Generic tracking options for controlling provider behavior
 * Extensible interface for future tracking controls
 */
export interface TrackingOptions {
    /** Meta Limited Data Use options - applied for purchase events in affected states */
    ldu?: LDUOptions | null;

    // Future extensibility:
    // /** Override consent for specific events */
    // consentOverride?: boolean;
    // /** Custom provider-specific params */
    // providerParams?: Record<string, Record<string, unknown>>;
    // /** User location for geo-targeted tracking */
    // userLocation?: { country?: string; state?: string; };
}

/**
 * Tracking info from a single external ad platform after server-side event send
 */
export interface ExternalAdPlatformTrackingInfo {
    /** Platform that received the event (e.g., 'Meta', 'GoogleAds', 'TTD') */
    provider: string;
    /** Unique event ID for deduplication with browser pixel */
    eventId: string;
    /** Whether the server-side event was sent successfully */
    success: boolean;
    /** Error message if the event failed */
    error?: string;
    /** HTTP status code from the platform API */
    statusCode?: number;
}

export interface SimpleTrackingProvider {
    enableDebug: () => void;
    track: ({
        brandId,
        pixels,
        eventName,
        eventType,
        eventPayload,
        trackingOptions,
        externalTracking,
    }: {
        brandId: string;
        pixels: TrackingPixel[];
        eventName: string;
        eventType: BrandclubEventType;
        eventPayload: any;
        /** Optional tracking options (LDU, etc.) */
        trackingOptions?: TrackingOptions | null;
        /** External tracking reports from server-side events (for deduplication) */
        externalTracking?: ExternalAdPlatformTrackingInfo[];
    }) => void;
    grantConsent?: () => void;
    revokeConsent?: () => void;
}